import React, {useEffect, useState} from "react";
import Slider from "react-slick";
import { BannerSliderData } from "../../Utils/constants";
import { isEmpty } from "lodash";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate,Link } from "react-router-dom";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { jackpotGameData } from "../../constraints/constants";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import jpbanner from "../../assets/images/jackpot-banner.webp";
import jptitle from "../../assets/images/jp-title.webp";



const JackpotGameSlider = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    arrows: false,
    slidesToScroll:3,
    centerPadding:'10px',
    slidesToShow: 3,
    // rows: 2,
    slidesPerRow: 1
  };
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchEGTCasino = useContextSelector(AuthContext, (ctx) => ctx.launchEGTCasino);
  const launchCasino = useContextSelector(AuthContext, (ctx) => ctx.launchCasino);
  const withoutLogin = useContextSelector(AuthContext, (ctx) => ctx.withoutLogin);
  const navigate = useNavigate();
const scrollDigits = document.querySelectorAll(".scroll-num ul");

scrollDigits.forEach((ul) => {
  setInterval(() => {
    const randomDigit = Math.floor(Math.random() * 10);
    ul.style.transform = `translateY(-${randomDigit * 0.7}rem)`;
  }, 5000); // every 5 seconds
});
  return (
    <>
    < div className="slider-heading">
    {/* <h3>Live Casino</h3> */}
    {/* <Link to={"/casino?header=livecasino&subCasino="}>See All</Link> */}
    </div>
    <div class="jackpot-wrap">
  <div class="corner-icons">
    <div class="corner top-left"></div>
    <div class="corner top-right"></div>
    <div class="corner bottom-left"></div>
    <div class="corner bottom-right"></div>
    <div class="jackpot-bg">
      <img class="jp-banner" src={jpbanner} alt=""/>
      <img class="jp-title" src={jptitle}/>
      <div class="jackpot-box">
        <div class="jackpot-num">
          <div class="jackpot-num-list">
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="point">,</div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="point">,</div>
            <div class="scroll-num">
              <ul class="animate-list"  >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list"  >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="point">.</div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
            <div class="scroll-num">
              <ul class="animate-list" >
                <li style={{height: `0.7rem`}}>0</li>
                <li style={{height: `0.7rem`}}>1</li>
                <li style={{height: `0.7rem`}}>2</li>
                <li style={{height: `0.7rem`}}>3</li>
                <li style={{height: `0.7rem`}}>4</li>
                <li style={{height: `0.7rem`}}>5</li>
                <li style={{height: `0.7rem`}}>6</li>
                <li style={{height: `0.7rem`}}>7</li>
                <li style={{height: `0.7rem`}}>8</li>
                <li style={{height: `0.7rem`}}>9</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
      </div>
      {/* <div className="hotgame-slider border-0 p-0">
        <div>
          <Slider {...settings}>
            {jackpotGameData?.map((item) => {
              return (
                <div
                  onClick={() => {
                    if (!isEmpty(user)) {
                      launchCasino({
                        platForm: item?.platForm,
                        gameType: item?.gameType,
                        casinoType: item?.casinoType,
                        isLobbyTrue:true
                      });
                    } else {
                      navigate("/login");
                    }
                  }}
                  className="slider-items"
                >
                  <figure className="mb-0 shine">
                   <ImageWithPlaceholder src={item?.img} alt={item?.img} />
                  </figure>
                </div>
              );
            })}
          </Slider>
        </div>
      </div> */}
    </>
  );
};

export default JackpotGameSlider;
